import React from 'react';
import { LiaFileContractSolid } from 'react-icons/lia';

export const TENDER_CHILD_ROUTES = ['/tenders/archive'];

/**
 * Is this pathname inside the tender workspace?
 *
 * Every tender screen hangs off `/tenders` — the list, the archive, the room
 * (`/tenders/:id`) and its ledger — so one prefix covers the workspace. Keeping
 * the rule here means the sidebar and anything else that needs it agree.
 */
export function isTenderWorkspaceRoute(pathname) {
  const path = String(pathname || '');
  return path === '/tenders' || path.startsWith('/tenders/');
}

/**
 * Tender Management — sits above Project in the sidebar because that is the real
 * order of the business: you bid first, and only then is there a project.
 *
 * Unlike the project sections this needs no `activeProject`: a tender exists
 * before any project does.
 *
 * Two gates, not one. The menu permission says the user may reach the module;
 * `tenderAccess.hasAccess` (a live TenderAccessGrant, from the access manifest)
 * says there is something in it for them. Both are required, because the
 * workspace is dead weight during operations for everyone not bidding — and
 * before this, a user with the permission and no grant was offered a door into
 * an empty room.
 *
 * The count is on the label on purpose: during operations this menu should
 * either be absent or be telling you something.
 */
export default function TendersNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  tenderAccess,
}) {
  if (!tenderAccess?.hasAccess) {
    return null;
  }
  if (!hasMenuAccess('/tenders') && !hasMenuAccessOrChild('/tenders', TENDER_CHILD_ROUTES)) {
    return null;
  }

  const openCount = tenderAccess.openCount || 0;

  return (
    <MenuItem
      customIcon={<LiaFileContractSolid style={{ width: '24px', height: '24px' }} />}
      title={openCount > 0 ? `Tender Management (${openCount})` : 'Tender Management'}
      id="tenders"
    >
      {hasMenuAccess('/tenders') && <SubMenuItem to="/tenders">Active Tenders</SubMenuItem>}
      {hasMenuAccess('/tenders/archive') && (
        <SubMenuItem to="/tenders/archive">Tender Archive</SubMenuItem>
      )}
    </MenuItem>
  );
}
